import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import { theme, useStyles } from './LoadingPage.styles';
import { ThemeProvider } from '@material-ui/core/styles';

const LoadingPage: React.FC<{ message?: string | null }> = ({ message = "Przekierowanie" }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <ThemeProvider theme={theme}>
        <CircularProgress className={classes.loader} />
      </ThemeProvider>
      {message !== null && <span className={classes.text}>{message}</span>}
    </div>
  );
};

export default LoadingPage;
